<template>
    <div id="ci-input">
        <b-form-group
            v-show="!altNumberInput"
            :ref="'ci-input-' + _uid"
            :label="label"
            :label-for="labelFor"
            :aria-disabled="disabled"
            :invalid-feedback="invalidFeedback && invalidFeedback.msg"
            :state="invalidFeedback && invalidFeedback.status"
            :class="{ 'isPassword-form-group': type == 'password', required: required, gray: gray }"
        >
            <b-form-input
                ref="input"
                :class="{ 'input-dark': dark }"
                v-model="content"
                @input="handleInput"
                @focus="customFocus"
                @blur="customBlur"
                :autocomplete="autocomplete"
                :id="id"
                :disabled="disabled"
                :maxlength="maxlength"
                :required="required"
                :type="type"
                :can-show-password="canShowPassword"
            />
            <div class="eye-slash-icon-container" v-if="canShowPassword && !showingPassword" @click="changeInputType('text')">
                <icon name="eye-slash" class="eye-slash-icon" />
            </div>
            <div class="eye-icon-container" v-if="canShowPassword && showingPassword" @click="changeInputType('password')">
                <icon name="eye" class="eye-icon" />
            </div>
        </b-form-group>
        <div v-show="type == 'number' && altNumberInput" class="number-input-container">
            <span class="number-label">{{ label }}</span
            ><b-form-input ref="input" class="number-input ml-2" v-model="content" :type="type" />
            <div class="number-controls">
                <div class="up-arrow" @click="increaseNumber"><icon name="arrow-up" class="arrow-up" /></div>
                <div class="down-arrow" @click="decreaseNumber"><icon name="arrow-down" class="arrow-down" /></div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-awesome/icons/eye-slash'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/arrow-up'
import 'vue-awesome/icons/arrow-down'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
    name: 'ci-input',
    components: {
        vueCustomScrollbar,
    },
    props: {
        label: String,
        change: Function,
        changeParams: null,
        labelFor: String,
        invalidFeedback: Object,
        id: String,
        min: Number,
        max: Number,
        dark: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: String,
            default: '524288',
        },
        gray: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        altNumberInput: {
            type: Boolean,
            default: false,
        },
        canShowPassword: {
            type: Boolean,
        },
        debounce: {
            type: Number,
            default: 0,
        },
        autocomplete: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            scrollBarSettings: {
                suppressScrollX: true,
            },
            showingPassword: false,
            content: '',
            element: '',
            isFocused: false,
            inputTimeout: null,
        }
    },
    updated() {
        this.handleInput()
    },
    watch: {
        '$attrs.value': function () {
            if (this.type == 'number') {
                if (this.max && this.$attrs.value > this.max) {
                    this.$attrs.value = this.max
                }
                if (this.min && this.$attrs.value < this.min) {
                    this.$attrs.value = this.min
                }
            }
            this.content = this.$attrs.value
            let element = document.getElementById('ci-input-' + this._uid)
            if (this.content == '' && document.activeElement == element) {
                let label = this.element.getElementsByTagName('label')[0]
                label.classList.remove('input-focused')
            }
            if (this.type == 'date') {
                let input = document.getElementById(this.id)
                let label = document.querySelector('label[for=' + this.id + ']')
                label.classList.add('input-focused')
                input.classList.remove('date-unfocused')
                input.classList.add('date-focused')
            }
        },
    },
    methods: {
        increaseNumber() {
            this.content++
        },
        decreaseNumber() {
            this.content--
        },
        handleInput(e) {
            clearTimeout(this.inputTimeout)
            if (this.content.length == 0) {
                this.$emit('input', this.content)
            } else {
                this.inputTimeout = setTimeout(() => {
                    this.$emit('input', this.content)
                }, this.debounce)
            }

            let label = document.querySelector('label[for=' + this.id + ']')
            if (label) {
                label.classList.remove('input-unfocused')
                label.classList.add('input-focused')
            }
        },
        focusOnLabelClick() {
            let label = document.getElementsByTagName('label')
        },
        customFocus(el) {
            let element = el.target
            let label = document.querySelector('label[for=' + element.id + ']')
            if (label) {
                label.classList.add('input-focused')
            }
            if (element && element.type == 'date' && element.value == '') {
                element.classList.remove('date-unfocused')
                element.classList.add('date-focused')
            }
            this.isFocused = true
        },
        customBlur(el) {
            let element = el.target
            let label = document.querySelector('label[for=' + element.id + ']')
            if (label) {
                if (element.value == '') {
                    label.classList.remove('input-focused')
                }
            }
            if (element && element.type == 'date' && element.value == '') {
                element.classList.remove('date-focused')
                element.classList.add('date-unfocused')
            }
            this.isFocused = false
        },
        // handleInputReset() {
        //   let element = this.$refs['ci-input-' + this._uid].$el
        //   let label = document.querySelector("label[for=" + element.id + "]")
        //   if (label) {
        //     if (element.value == "") {
        //       label.classList.remove('input-focused')
        //     }
        //   }
        //   if (element.type == "date" && element.value == "") {
        //     element.classList.remove('date-focused')
        //     element.classList.add('date-unfocused')
        //   }
        // },
        changeInputType(type) {
            let input = document.getElementById(this.id)
            if (input) {
                input.type = type
                if (type == 'text') {
                    this.showingPassword = true
                }
                if (type == 'password') {
                    this.showingPassword = false
                }
            }
        },
        checkDateType() {
            let input = document.getElementById(this.id)
            if (input && input.type == 'date') {
                input.classList.add('date-unfocused')
            }
        },
    },
    mounted() {
        this.element = this.$refs['ci-input-' + this._uid].$el
        this.checkDateType()
        if (this.$attrs.value) this.content = this.$attrs.value
    },
}
</script>

<style lang="scss">
#ci-input {
    .eye-slash-icon-container {
        height: 19px;
        width: 19px;
        float: right;
        position: relative;
        right: 16px;
        bottom: calc(23px + 12px);
        cursor: pointer;
        .eye-slash-icon {
            color: var(--light);
            width: 19px;
        }
    }
    .eye-icon-container {
        height: 19px;
        width: 19px;
        float: right;
        position: relative;
        right: 16px;
        bottom: calc(23px + 12px);
        cursor: pointer;
        .eye-icon {
            color: var(--light);
            width: 19px;
        }
    }
    .form-control {
        color: var(--light) !important;
        background-color: transparent !important;
        border: 0px !important;
        border-bottom: 2px var(--light) solid !important;
        padding-right: 8px !important;
        padding-left: 8px !important;
        padding-top: 12px !important;
        padding-bottom: 12px !important;
        height: auto !important;
        &::placeholder {
            text-transform: uppercase;
        }
        &[type='date']::-webkit-clear-button {
            -webkit-appearance: none;
            margin: 0;
        }
        &[type='date']::-webkit-calendar-picker-indicator {
            background: transparent !important;
        }
    }

    .date-focused {
        color: var(--light) !important;
        transition: color 0.35s;
    }
    .date-unfocused {
        color: rgba(245, 245, 245, 0) !important;
        transition: color 0.35s;
    }

    .form-group {
        &[aria-disabled] {
            label,
            input {
                opacity: 0.25 !important;
            }
        }
        label {
            color: var(--light);
            text-transform: uppercase;
            margin: 0;
            position: relative;
            top: 36px;
            cursor: text;
            transition: all 0.2s;
            line-height: 16px !important;
        }
        .input-focused {
            top: 8px;
            font-size: 0.75rem;
            transition: all 0.2s;
        }
    }

    .number-input-container {
        display: grid;
        align-items: center;
        grid-template-columns: repeat(3, max-content);
        .number-input {
            display: inline-block !important;
            max-width: 40px !important;
            border: none !important;
            background: var(--primary) !important;
            border-top-left-radius: 7px !important;
            border-bottom-left-radius: 7px !important;
            text-align: right !important;
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            -moz-appearance: textfield;
            appearance: textfield;
        }
        .number-controls {
            display: grid;
            grid-template-rows: repeat(2, max-content);
            margin-left: 1px;
            .up-arrow {
                cursor: pointer;
                background: var(--primary);
                width: 15px;
                height: 16.5px;
                margin-bottom: 1px;
                border-top-right-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                &:active {
                    background: var(--secondary);
                }
            }
            .down-arrow {
                cursor: pointer;
                background: var(--primary);
                width: 15px;
                height: 16.5px;
                border-bottom-right-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                &:active {
                    background: var(--secondary);
                }
            }
            svg {
                height: 8px !important;
                width: 8px !important;
            }
        }
    }

    .isPassword-form-group {
        margin-bottom: 0px !important;
    }

    .required {
        label::after {
            content: '*';
            color: var(--secondary);
            margin-left: 0.5rem;
        }
    }

    .gray {
        .form-control {
            border-bottom: 2px var(--gray) solid !important;
        }
    }

    .is-invalid {
        input {
            color: var(--danger) !important;
            border-bottom: 2px solid var(--danger) !important;
        }
    }

    .input-dark {
        background: var(--primary) !important;
        border-bottom: none !important;
        padding-top: 6px !important;
        padding-bottom: 6px !important;
    }

    @media (min-width: 200px) and (max-width: 768px) {
        .form-group label {
            font-size: 12px !important;
            top: 42px !important;
        }
        .form-group .input-focused {
            top: 8px !important;
        }
    }
}
</style>
